import { Button, ButtonSizeMD } from '@picsart/button';
import { useTranslator } from '@picsart/rc/services/localization';
import IconDownload from '@picsart/icons/IconDownload';
import { HorizontalPositions, SuggestionMenu, SuggestionMenuPositions } from '@picsart/suggestionmenu';
import { ChangeEvent, useRef, useState } from 'react';

import useClickOutside from 'hooks/common/useClickOutside';
import analytics from 'pages/Batch/utils/analytics';
import useBatchData from 'pages/Batch/sections/Context/useBatchData';

import DownloadImageMenu from '../DownloadImageMenu';

import testIds from './testIds';
import useStyles from './styles';

interface IExportProps {
    isDisabled: boolean;
}
const DesktopExport = ({ isDisabled }: IExportProps) => {
  const translate = useTranslator();
  const [downloadMenuIsOpen, setDownloadMenuIsOpen] = useState(false);
  const classes = useStyles();
  const { selectedData } = useBatchData();

  const buttonRef = useRef<HTMLButtonElement>(null);

  const outsideClickHandler = (event: ChangeEvent<HTMLElement>) => {
    if (event.target !== buttonRef.current) {
      setDownloadMenuIsOpen(false);
      if (downloadMenuIsOpen) {
        analytics.exportAction('close');
      }
    }
  };

  const menuRef = useClickOutside(outsideClickHandler);

  const handleClickExport = () => {
    setDownloadMenuIsOpen(!downloadMenuIsOpen);
    if (downloadMenuIsOpen) {
      analytics.exportAction('close');
    }
  };

  const handleClose = (viaDownload = false) => {
    setDownloadMenuIsOpen(false);
    if (!viaDownload) {
      analytics.exportAction('close');
    }
  };

  return (
    <>
      <Button
        isDisabled={isDisabled}
        dataTestId={testIds.exportBtn}
        onClick={handleClickExport}
        endIcon={IconDownload}
        size={ButtonSizeMD}
        ref={buttonRef}
        className={classes.desktopExportButton}
      >
        {translate('Export')}
      </Button>

      <SuggestionMenu
        ref={menuRef}
        relativeRef={buttonRef}
        isOpen={downloadMenuIsOpen}
        position={SuggestionMenuPositions.Bottom}
        alignment={HorizontalPositions.Left}
        className={classes.suggestionMenu}
      >
        <DownloadImageMenu
          onClose={handleClose}
          showZipNameField={selectedData.length > 1}
        />
      </SuggestionMenu>
    </>
  );
};

export default DesktopExport;
